import { create } from 'zustand';
import { apiService } from '../services/api';
import { useAppStore } from './appStore';
import { workspaceAssistantState } from './workspaceAssistantState';

export const useWorkspaceAssistantStore = create(workspaceAssistantState(apiService));

// Hide and discard in-memory business conversations immediately on logout or business switch.
useAppStore.subscribe((next, previous) => {
  if (next.currentBusiness?._id !== previous.currentBusiness?._id || next.user?.id !== previous.user?.id || next.isAuthenticated !== previous.isAuthenticated) {
    useWorkspaceAssistantStore.getState().activate('');
    useWorkspaceAssistantStore.getState().setAssistantTab(false);
  }
});
